<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')">
        <el-col :span="24">
          <el-form-item :label="$t('manage.name37')" prop="name">
            <el-input v-model="queryInfo.name" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getSysmenutemplateList" v-if="buttonPerms.indexOf('sysmenu/list') > -1">{{ $t('public.name3') }}</el-button>
        <el-button size="medium">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary"  size="medium" @click="addRule" v-if="buttonPerms.indexOf('sysmenu/add') > -1">{{ $t('manage.name115') }}</el-button>
    </div>

    <el-tabs style="margin-top:30px" v-model="activeName" @tab-click="handleClick">
  <el-tab-pane :label="$t('manage.name116')" name=0></el-tab-pane>
  <el-tab-pane :label="$t('manage.name117')" name=1></el-tab-pane>
  <el-tab-pane :label="$t('manage.name118')" name=22></el-tab-pane>
  <el-tab-pane :label="$t('manage.name119')" name=32></el-tab-pane>
  <el-tab-pane :label="$t('manage.name120')" name=20></el-tab-pane>
  <el-tab-pane :label="$t('manage.name121')" name=21></el-tab-pane>
  <el-tab-pane :label="$t('manage.name122')" name=30></el-tab-pane>
  <el-tab-pane :label="$t('manage.name123')" name=31></el-tab-pane>
  <el-tab-pane :label="$t('manage.name124')" name=4></el-tab-pane>
</el-tabs>
    <el-tree :data="treeDataList"  node-key="menuId" :default-expand-all="true"  :props="defaultProps">
            <template slot-scope="{ data }">
              <span v-if="lang === 'zh'">{{ data.menuName }}</span>
              <span v-else>{{ data.emenuName }}</span>
            </template>
    </el-tree>
    <AppDialog width="688px" :title="$t('manage.name43')" v-if="roleInfoDialog" :visible.sync="roleInfoDialog" :before-close="close">
      <el-form :label-width="formLabelWidth('lg')">
        <el-form-item prop="status" :label="$t('manage.name33')">
          <el-radio v-model="roleInfo.status" label="1">{{ $t('manage.name34') }}</el-radio>
          <el-radio v-model="roleInfo.status" label="0">{{ $t('manage.name35') }}</el-radio>
        </el-form-item>
        <el-form-item prop="name" :label="$t('manage.name36')">
          <el-tree :data="treeData" show-checkbox node-key="menuId" :default-expand-all="true" :default-checked-keys="checkedKeys" :props="defaultProps" @check="chechChange">
            <template slot-scope="{ data }">
              <span v-if="lang === 'zh'">{{ data.menuName }}</span>
              <span v-else>{{ data.emenuName }}</span>
            </template>
          </el-tree>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { sysmenuList, sysmenutemplateList, sysmenutemplateUpdate, getIdByTenantType } from '@/api/manage.js'
import AppDialog from '@/components/AppDialog/index.vue'
import { getStoredLocale } from '@/config/flavor'
export default {
  components: { AppDialog },
  data() {
    return {
      activeName: 0,
      queryInfo: {
        page: 1,
        limit: 10,
        name: '',
        status: 2
      },
      total: 0,
      selectList: [],
      treeDataList: [],
      type: 1,
      roleInfo: {
        status: '1',
        id: ''
      },
      treeData: [],
      defaultProps: {
        children: 'childList',
        label: 'menuName'
      },
      roleInfoDialog: false,
      loading: false,
      checkedKeys: [],
      halfCheckedKeys: [],
      buttonPerms: '',
      lang: ''
    }
  },
  created() {
    this.lang = getStoredLocale()
    this.buttonPerms = localStorage.getItem('buttonPerms')
    this.getSysmenutemplateList()
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      console.log('tab===', tab.name)
      this.activeName = tab.name
      this.getSysmenutemplateList()
    },
    addRule() {
      this.roleInfoDialog = true
      this.getSysMenuTree()
    },
    close() {
      this.roleInfoDialog = false
    },
    submitForm() {
      this.loading = true
      let status = true
      if (this.roleInfo.status === '1') {
        status = true
      } else {
        status = false
      }
      const data = {
        rules: this.checkedKeys.join(','),
        rulesBak: this.halfCheckedKeys.join(','),
        tenantType: parseInt(this.activeName),
        status: status
      }
      sysmenutemplateUpdate(data)
        .then((res) => {
          this.loading = false
          if (res.code === 200) {
            this.close()
            this.getSysmenutemplateList()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    chechChange(data1, data2) {
      this.checkedKeys = []
      data2.checkedKeys.map(item => {
        this.checkedKeys.push(item)
      })
      this.halfCheckedKeys = []
      data2.halfCheckedKeys.map(item => {
        this.halfCheckedKeys.push(item)
      })
    },

    getSysMenuTree() {
      const data = {
        page: 1,
        limit: 500
      }

      sysmenuList(data)
        .then(res => {
          this.treeData = res.data.list
        })
        .catch(() => {})
    },

    getSysmenutemplateList() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name44'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.treeDataList = []
      const data = {
        name: this.queryInfo.name,
        tenantType: this.activeName
      }
      sysmenutemplateList(data)
        .then((res) => {
          loading.close()
          this.checkedKeys = []
          this.treeDataList = res.data
          this.getIdByTenantTypeData()
        })
        .catch(() => {})
    },
    getIdByTenantTypeData() {
      const data = {
        tenantType: this.activeName
      }
      getIdByTenantType(data)
        .then(res => {
          this.checkedKeys = res.data
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss">
 .el-tree{
 font-size: 14px;
 }

</style>

<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      line-height: 16.8px;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
.map {
  width: 100%;
  height: 800px;
}
</style>
